import Message from "../../message";
import {useMainStore} from "@/store";
import EchoManager from "@/services/echo-manager";

export default class MemberQuit extends Message
{
    handle()
    {
        if (this.message.user_id === useMainStore().id) {
            EchoManager.unsubscribeChannel('guild');
            useMainStore().SET_GUILD(null);
        } else {
            useMainStore().REMOVE_GUILD_MEMBER(this.message.user_id);
        }
    }
}
